import { render } from "./setColor.vue?vue&type=template&id=c683291a&scoped=true"
import script from "./setColor.vue?vue&type=script&lang=js"
export * from "./setColor.vue?vue&type=script&lang=js"

import "./setColor.vue?vue&type=style&index=0&id=c683291a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c683291a"

export default script